<page-title [title]="title"></page-title>

<p *ngIf="currentUser.type == 'patient'">Aqui você pode consultar e gerenciar as suas consultas.</p>

<form class="row">
  <div class="col-xs-12 col-md-3">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Especialista/Exame</mat-label>
      <mat-select [(value)]="encounterType">
        <mat-option *ngFor="let item of filterTipos; let i = index" [value]="i">
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-xs-12 col-md-9">
    <div class="search-container">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Buscar agendamento</mat-label>
        <input
          type="text"
          matInput
          [formControl]="searchEncounterControl"
          (focus)="onInputFocus()"
          (blur)="onInputBlur()"
          placeholder="Busque por: nome do especialista, instituição ou serviço"
        />

        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <mat-card *ngIf="showAutocompletePanel" class="autocomplete-panel">
        <mat-list>
          <mat-list-item *ngFor="let suggestion of autocompleteSuggestions" (mousedown)="selectSuggestion(suggestion)" class="suggestion-item">
            <mat-icon matListIcon>search</mat-icon>
            <div matLine>{{ suggestion }}</div>
          </mat-list-item>
        </mat-list>
      </mat-card>
    </div>
  </div>
</form>

<div *ngIf="searchEncounter && searchEncounter.length >= 2" class="results-count">
  {{ atendimentosFiltro.length }} agendamento{{ atendimentosFiltro.length !== 1 ? 's' : '' }} encontrado{{
    atendimentosFiltro.length !== 1 ? 's' : ''
  }}
</div>

<mat-tab-group>
  <mat-tab *ngFor="let tab of tabs" [label]="tab.title">
    <div class="col-xs-12 encounters-list" *ngFor="let encounter of getContent(tab.id)">
      <mat-card style="padding: 10px; margin-top: 20px">
        <div class="col-md-12">
          <h3 *ngIf="!encounter.byOrderInfo?.isByOrder">
            {{ layout.dateTimeFormat(encounter.plannedStartDate) }} - {{ encounter.type }}
            <mat-chip color="accent" class="float-right" [ngClass]="getColorStatus(encounter.status, false, encounter.status_payment)">
              {{ getTextStatus(encounter.status) }}
            </mat-chip>
          </h3>
          <h3 *ngIf="encounter.byOrderInfo?.isByOrder">
            {{ layout.dateFormat(encounter.plannedStartDate) }} - {{ encounter.type }}
            <mat-chip color="accent" class="float-right" [ngClass]="getColorStatus(encounter.status, true, encounter.status_payment)">
              {{ getTextStatus(encounter.status, true) }}
            </mat-chip>
          </h3>
        </div>

        <div class="col-xs-12">
          <div class="content" *ngIf="encounter.type == 'Consulta'">
            <b>Especialista: </b> {{ encounter.practitioner.name }} <br />
            <b>Instituição: </b> {{ encounter.organization.name }}
          </div>
          <div class="content" *ngIf="encounter.type == 'Exame'">
            <b>Exame:</b> {{ encounter.name }} <br />
            <b>Especialista:</b> {{ encounter.practitioner?.name }} <br />
            <b>Instituição:</b> {{ encounter.organization?.name }}
          </div>
          <!-- <div class="content"><b>Forma de agendamento:</b> {{ encounter.scheduling_method }}</div> -->
          <div><b>Valor do pagamento:</b> R${{ encounter.value }}</div>
          <div><b>Status pagamento:</b> {{ getStatusPaymentText(encounter.status_payment) }}</div>
        </div>

        <div class="col-xs-12">
          <div class="actions">
            <button
              mat-flat-button
              color="primary"
              (click)="openPaymentEncounter(encounter)"
              [disabled]="loading"
              *ngIf="isPaymentActionAvailable(encounter)"
            >
              Pagar
            </button>
            <button mat-flat-button color="primary" (click)="openDetailsEncounter(encounter)" [disabled]="loading">Ver detalhes</button>
          </div>
        </div>
      </mat-card>
    </div>

    <div *ngIf="searchEncounter && searchEncounter.length >= 3 && getContent(tab.id).length === 0" class="no-results">
      <mat-icon>search_off</mat-icon>
      <p>Nenhum agendamento encontrado para "{{ searchEncounter }}"</p>
    </div>

    <div class="pagination-controls" *ngIf="(tab.id === 1 ? atendimentosEmAberto.length : atendimentosFinalizados.length) > itemsPerPage">
      <button mat-stroked-button color="primary" (click)="changePage(tab.id, 'prev')" [disabled]="currentPage[tab.id] === 1">Anterior</button>

      <span style="margin: 0 10px"> Página {{ currentPage[tab.id] }} de {{ getTotalPages(tab.id) }} </span>

      <button mat-stroked-button color="primary" (click)="changePage(tab.id, 'next')" [disabled]="currentPage[tab.id] >= getTotalPages(tab.id)">
        Próxima
      </button>
    </div>
  </mat-tab>
</mat-tab-group>
